export default "__VITE_ASSET__CViBzkcv__"